import PIESideSheet from '@src/shared/components/PIESideSheet';
import React from 'react';
import { DeliveryDashboardScreens } from '../../models/model-enum';
import { useDashboardUIStore } from '../../store/dashboardUIStore';
import { PIEComponentUtil } from '@src/shared/components/PIEComponentUtil';
import useDeviceDetect from '@src/shared/hooks/use-device-detect';
import styles from './DashboardMapSettings.module.scss';
import PIEText from '@src/shared/components/PIEText';
import PIESwitch from '@src/shared/components/PIESwitch';
import PIENotification, { IPieNotificationMode } from '@src/shared/components/PIENotification';
import { useCommonPersistentStore } from '@src/shared/store/common-persistent-store';
import { useTranslation } from 'react-i18next';

const DashboardMapSettings = () => {
  const { t } = useTranslation();
  const { setActiveScreen } = useDashboardUIStore();
  const { isResolutionMobile } = useDeviceDetect();
  const { settings, setShowOrderClustersSetting } = useCommonPersistentStore();
  return (
    <PIESideSheet
      title={t('mapSettings.SIDE_SHEET_TITLE')}
      width={357}
      isOpenInitial={true}
      marginTop={isResolutionMobile ? 0 : 56}
      onClose={() => {
        setActiveScreen(DeliveryDashboardScreens.MANAGE_DELIVERY_SCREEN);
      }}
    >
      <PIEComponentUtil padding="var(--xds-spacing-d)">
        <div className={styles.DashboardMapSettingsToggler}>
          <PIEText
            text={t('mapSettings.ORDER_CLUSTERING_TITLE')}
            color="var(--xds-color-content-bold)"
            size="var(--xds-font-size-14)"
            fontWeight="var(--xds-font-weight-bold)"
          />
          <PIESwitch
            label={
              settings.showOrderClusters
                ? t('mapSettings.SWITCH_LABEL_ON')
                : t('mapSettings.SWITCH_LABEL_OFF')
            }
            labelPosition={'left'}
            setOnByDefault={!!settings.showOrderClusters}
            onChange={() => {
              setShowOrderClustersSetting(!settings.showOrderClusters);
            }}
          ></PIESwitch>
        </div>
      </PIEComponentUtil>
      <PIEComponentUtil padding="var(--xds-spacing-b)">
        <PIENotification
          mode={IPieNotificationMode.Neutral}
          isOpen={true}
          modInline={true}
          showClose={false}
        >
          {t('mapSettings.CLUSTERING_INFO_TEXT')}
        </PIENotification>
      </PIEComponentUtil>
    </PIESideSheet>
  );
};
export default DashboardMapSettings;
